import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';
import _get from 'lodash/get';

import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../utils/formConfig';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { addCsvDetails, getTransactionTypeOptions, uploadCsvDetails } = useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.TYPE_BUCKET].setRenderProps({ getOptions: getTransactionTypeOptions });

	const createWallet = async (createdData: any) => {
		try {
			const { csvData } = createdData;
			const formData = new FormData();
			setShowLoader(true);

			_forEach(_keys(csvData), (key: string) => {
				formData.append(key, csvData[key]);
			});
			const result = await uploadCsvDetails(formData);
			const csvUrl = _get(result, ['data', 'fileUrl']);

			const csvFinalData = { ...csvData, csvUrl };
			await addCsvDetails(csvFinalData);
			showAlert('CSV uploaded');
			setShowLoader(false);
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		createWallet(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
